// src/pages/AdminLogin.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdmin } from "../admin/AdminContext";

const AdminLogin = () => {
  const [key, setKey] = useState("");
  const [error, setError] = useState("");
  const { login } = useAdmin();
  const navigate = useNavigate();

  const onSubmit = (e) => {
    e.preventDefault();
    console.log("[ADMIN] Login form submitted");
    setError("");

    const ok = login(key);
    if (!ok) {
      setError("Please enter a valid admin API key.");
      return;
    }

    navigate("/admin");
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "radial-gradient(circle at top, #0f172a, #020617)",
        color: "#e5e7eb",
        fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'SF Pro', sans-serif",
      }}
    >
      <form
        onSubmit={onSubmit}
        style={{
          width: 340,
          maxWidth: "90vw",
          borderRadius: 16,
          padding: 20,
          background:
            "linear-gradient(145deg, rgba(15,23,42,0.96), rgba(15,23,42,0.99))",
          border: "1px solid rgba(148,163,184,0.4)",
          boxShadow: "0 24px 60px rgba(15,23,42,0.9)",
        }}
      >
        <div style={{ fontSize: 20, fontWeight: 600, marginBottom: 4 }}>
          Admin Login
        </div>
        <div style={{ fontSize: 12, color: "#9ca3af", marginBottom: 16 }}>
          Enter the backend admin API key to view active rooms & users.
        </div>

        <label
          style={{
            display: "block",
            fontSize: 12,
            marginBottom: 4,
            color: "#cbd5f5",
          }}
        >
          Admin API Key
        </label>
        <input
          type="password"
          value={key}
          onChange={(e) => setKey(e.target.value)}
          style={{
            width: "100%",
            padding: "8px 10px",
            borderRadius: 999,
            border: "1px solid rgba(148,163,184,0.7)",
            outline: "none",
            background: "rgba(15,23,42,0.9)",
            color: "#f9fafb",
            fontSize: 13,
            marginBottom: 10,
          }}
        />

        {error && (
          <div
            style={{
              fontSize: 11,
              color: "#fecaca",
              marginBottom: 8,
            }}
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          style={{
            width: "100%",
            padding: "8px 10px",
            borderRadius: 999,
            border: "none",
            background:
              "linear-gradient(135deg, #0ea5e9, #2563eb, #4f46e5)",
            color: "#f9fafb",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          Login
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
